import axios from './axios.setup.js';

/**
 * Just a shortcut to avoid repeating the route prefix
 * @param {string} url
 * @param {string} accountId The account uuid
 * @param {any} params
 */
export async function accountGet(url, accountId, params) {
  return await axios.get(`/accounts/${accountId}/${url}`, { params });
}

/**
 * Just a shortcut to avoid repeating the route prefix
 * @param {string} url
 * @param {string} accountId The account uuid
 * @param {any} params
 */
export async function accountPost(url, accountId, data) {
  return await axios.post(`/accounts/${accountId}/${url}`, data);
}

/**
 * Just a shortcut to avoid repeating the route prefix
 * @param {string} url
 * @param {string} accountId The account uuid
 * @param {any} params
 */
export async function accountPut(url, accountId, data) {
  return await axios.put(`/accounts/${accountId}/${url}`, data);
}

/**
 * Just a shortcut to avoid repeating the route prefix
 * @param {string} url
 * @param {string} accountId The account uuid
 * @param {any} params
 */
export async function accountPatch(url, accountId, data) {
  return await axios.patch(`/accounts/${accountId}/${url}`, data);
}

/**
 * Just a shortcut to avoid repeating the route prefix
 * @param {string} url
 * @param {string} accountId The account uuid
 */
export async function accountDelete(url, accountId) {
  return await axios.delete(`/accounts/${accountId}/${url}`);
}
